module.exports = __webpack_public_path__ + "fonts/geist.var.0be7ed5.woff";